import { render, staticRenderFns } from "./TabDiaphragm.vue?vue&type=template&id=917f1fb2&"
import script from "./TabDiaphragm.vue?vue&type=script&lang=js&"
export * from "./TabDiaphragm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports